import axios from "axios";
import { resolveApiUrl } from "../../assets/GlobalVariables";
import { TRIPMASTER_PUBLIC_SITE_TOKEN, isTripMasterSurface } from "./tripMasterEnv";

/** Saves a public TripMaster search. HotelsRiver agent searches stay on their own feed. */
export function recordTripMasterPublicSearch(payload) {
  if (!isTripMasterSurface() || !payload || typeof payload !== "object") return;
  const body = {
    siteId: TRIPMASTER_PUBLIC_SITE_TOKEN,
    category: payload.category,
    destination_label: payload.destination_label,
    destination_code: payload.destination_code,
    departure_date: payload.departure_date,
    return_date: payload.return_date,
    adults: payload.adults,
    children: payload.children,
    infants: payload.infants,
    rooms_count: payload.rooms_count,
  };
  void axios
    .post(resolveApiUrl("/api/tripmaster/public-searches"), body, { timeout: 8000 })
    .catch(() => {});
}
